export default __webpack_public_path__ + "media/images/front/search/search_category-200effc0c6b5b98796871da8c14661af.png";